import { Opacity } from '../../types/Camera/Opacity';

export const OpacityController = (props: Opacity) => {
  return (
    <>
      <div className="my-2 flex w-full flex-row justify-between">
        <button
          type="button"
          id="more-video"
          onClick={() => {
            props.setOpacity((Number(props.opacity) - 0.05).toString());
          }}
        >
          <p>Video</p>
        </button>
        <input
          id="transparency-slider"
          className="slider scale-[1.5]"
          type="range"
          min="35"
          max="90"
          value={props.opacity ? (Number(props.opacity) * 100).toString() : '65'}
          onChange={(e) => props.setOpacity((parseInt(e.target.value) / 100).toString())}
          disabled={props.scrolling}
        />
        <button
          type="button"
          id="more-text"
          onClick={() => {
            const newOpacity = (Number(props.opacity) + 0.05).toString();
            props.setOpacity(newOpacity);
          }}
        >
          <p>Text</p>
        </button>
      </div>
    </>
  );
};
